/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of TextAreaField.
 * @typedef {Object} TextAreaFieldType
 * @property {string} placeholder
 * @property {?number} rows
 * @property {boolean} autoExpand
 *
 * @typedef {QuestionFormFieldType & TextAreaFieldType} TextAreaFieldExtendType
 */

/**
 * Represents a text area form field.
 * @class
 */
export class TextAreaField extends QuestionFormField {
  /**
   * Create a new TextAreaField.
   * @param {TextAreaFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.placeholder = params.placeholder
    this.rows = params.rows
    this.autoExpand = params.autoExpand
  }
}
